import { useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { SolidButton } from "@components/button";
import { hasPgToken, pgLogin, toPgError } from "../pgApi";

const PgLoginPage = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const redirect = searchParams.get("redirect") || "/pg";

	const [account, setAccount] = useState("");
	const [password, setPassword] = useState("");
	const [submitting, setSubmitting] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	// 只接受站內路徑，避免 redirect 被帶到外站
	const safeRedirect = redirect.startsWith("/pg") ? redirect : "/pg";

	if (hasPgToken()) {
		return <Navigate to={safeRedirect} replace />;
	}

	const onSubmit = async (e) => {
		e.preventDefault();
		if (!account || !password || submitting) return;

		setSubmitting(true);
		setErrorMessage("");
		try {
			await pgLogin(account.trim(), password);
			navigate(safeRedirect, { replace: true });
		} catch (error) {
			setErrorMessage(toPgError(error).message);
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div className="flex min-h-svh flex-col items-center justify-center bg-white px-8">
			<img
				alt="TORY BURCH"
				className="mb-10 w-[200px]"
				src={window.assetUrl("/images/liff/brand-title.png")}
			/>
			<form className="w-full max-w-[360px]" onSubmit={onSubmit}>
				<h1 className="noto-sans-tc-medium mb-8 text-center text-[20px] text-[#292929]">
					現場兌換登入
				</h1>

				<label className="mb-1 block text-[14px] text-[#5c5c5c]" htmlFor="pg-account">
					帳號
				</label>
				<input
					id="pg-account"
					className="mb-6 block w-full border-0 border-b border-[#a8a8a8] px-0 py-2 focus:outline-none focus:ring-0"
					autoComplete="username"
					autoCapitalize="none"
					value={account}
					onChange={(e) => setAccount(e.target.value)}
				/>

				<label className="mb-1 block text-[14px] text-[#5c5c5c]" htmlFor="pg-password">
					密碼
				</label>
				<input
					id="pg-password"
					type="password"
					className="mb-4 block w-full border-0 border-b border-[#a8a8a8] px-0 py-2 focus:outline-none focus:ring-0"
					autoComplete="current-password"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
				/>

				<p className="mb-6 min-h-[20px] text-[13px] text-[#ff4750]">{errorMessage}</p>

				<SolidButton
					label={submitting ? "登入中…" : "登入"}
					buttonClass={
						"w-full rounded-[6px] py-3 text-[16px]" +
						(!account || !password || submitting ? " opacity-50" : "")
					}
				/>
			</form>
		</div>
	);
};

export default PgLoginPage;
